import { useState } from 'react';
import type { ConfirmModalProps } from '../components/shared/ConfirmModal';

export type ModalOptions = Omit<ConfirmModalProps, 'onConfirm' | 'onCancel'>;
type ModalState = ConfirmModalProps | null;

type ChoiceResult = 'confirm' | 'alt' | 'cancel';
type ChoiceOptions = Omit<ConfirmModalProps, 'onConfirm' | 'onAltConfirm' | 'onCancel'>;

export function useConfirmModal() {
    const [modal, setModal] = useState<ModalState>(null);

    const showConfirm = (opts: ModalOptions): Promise<boolean> =>
        new Promise((resolve) => {
            setModal({
                ...opts,
                onConfirm: () => { setModal(null); resolve(true); },
                onCancel:  () => { setModal(null); resolve(false); },
            });
        });

    const showChoice = (opts: ChoiceOptions): Promise<ChoiceResult> =>
        new Promise((resolve) => {
            setModal({
                ...opts,
                onConfirm:    () => { setModal(null); resolve('confirm'); },
                onAltConfirm: () => { setModal(null); resolve('alt'); },
                onCancel:     () => { setModal(null); resolve('cancel'); },
            });
        });

    return { modal, showConfirm, showChoice };
}